module.exports = __webpack_public_path__ + "47bbaf84ca44ff7cd128f7f62e1c0547.jpg";